var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "main_menu/Help") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "81.8949225%",
    y1: "53.4662025%",
    x2: "9.65286917%",
    y2: "53.4662025%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main_menu/Help",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(10.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,43.9531 C30,38.6791 25.688,36.0001 20.547,36.0001 L0,36.0001 L0,0.0001 L20.713,0.0001 C25.357,0.0001 30,3.3111 30,7.9531 L30,43.9531 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,43.9531 C30,38.6791 34.312,36.0001 39.453,36.0001 L60,36.0001 L60,0.0001 L39.287,0.0001 C34.643,0.0001 30,3.3111 30,7.9531 L30,43.9531 Z",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.287,0 C34.643,0 30,3.311 30,7.953 L30,43.953 C30,38.679 34.312,36 39.453,36 L42,36 L42,0 L39.287,0 Z",
    id: "Fill-6",
    fill: "url(#linearGradient-1)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.945,34.005 C33.034,33.627 31.656,33.308 30.332,33.308 L14,33.308 L14,31 L30.332,31 C31.656,31 33.034,31.319 33.945,31.697 L33.945,34.005 Z M33.945,39.3991 C33.034,39.0211 31.656,38.7021 30.332,38.7021 L14,38.7021 L14,36.3941 L30.332,36.3941 C31.656,36.3941 33.034,36.7131 33.945,37.0911 L33.945,39.3991 Z M33.945,54.0417 C33.034,53.6637 31.656,53.3447 30.332,53.3447 L14,53.3447 L14,41.7877 L30.332,41.7877 C31.656,41.7877 33.034,42.1067 33.945,42.4847 L33.945,54.0417 Z",
    id: "Combined-Shape",
    fill: "#777A80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.453,39.836 C50.791,39.836 48.633,41.994 48.633,44.656 C48.633,47.319 50.791,49.477 53.453,49.477 C56.115,49.477 58.273,47.319 58.273,44.656 C58.273,41.994 56.115,39.836 53.453,39.836 Z M49.957,32.963 C49.957,26.548 58.322,22.926 58.322,18.18 C58.322,16.387 57.719,14.981 56.631,13.958 C55.523,12.978 54.316,12.488 53.007,12.488 C51.395,12.488 50.077,13 49.051,14.021 C47.883,15.084 47.299,16.898 47.299,19.463 L41,19.463 L41,18.185 C41.041,14.653 42.217,11.755 44.53,9.49 C46.803,7.205 49.517,6 52.675,6 C56.086,6 59.025,7.117 61.338,9.235 C63.731,11.458 65.097,14.463 65.097,18.243 C65.097,25.502 56.263,28.032 56.263,34.268 L56.263,35.951 L49.957,35.951 L49.957,32.963 Z",
    id: "Fill-15",
    fill: "#00ABE3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.9d1b84d5736375cfa6c6fab1b83088ac.svg";
export { ForwardRef as ReactComponent };